export default {
  name: 'data',
  title: 'Data',
  owner: 'System',
  solution: '',
  tags: ['datasources', 'data'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    data: ['foo', 'bar', 'baz'],
    view: [['div', {}, '/${ $join(data, "," )}']],
  },
};
